import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { JoinedSession } from 'shared';
import { api } from '@/lib/api';

const BASE = '/api/activity-sessions';

/**
 * POST /api/activity-sessions/join — records the participant as present at the
 * session the scanned token belongs to. Scanning twice is harmless.
 *
 * Joining also checks the participant into the session's Centro when they had
 * no open visit, so the cached Centro state is refreshed on success.
 */
export function useJoinSession() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (token: string) => api.post<JoinedSession>(`${BASE}/join`, { token }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['centros'] });
    },
  });
}
